import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { NotACashGrabSection } from '../components/NotACashGrabSection';
import { ChillsSection } from '../components/ChillsSection';
import { WhatsInsideSection } from '../components/WhatsInsideSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { PricingSection } from '../components/PricingSection';
import { AverageRatingSection } from '../components/AverageRatingSection';
import { TestimonialsGridSection } from '../components/TestimonialsGridSection';
import { UrgencySection } from '../components/UrgencySection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { SocialProofNotification } from '../components/SocialProofNotification';
export const LandingV1 = () => <div className="w-full min-h-screen bg-bttf-bg text-bttf-text" data-id="element-1368">
    <Header data-id="element-1369" />
    <main data-id="element-1370">
      <HeroSection data-id="element-1371" />
      <NotACashGrabSection data-id="element-1372" />
      <ChillsSection data-id="element-1373" />
      <WhatsInsideSection data-id="element-1374" />
      <SocialProofSection data-id="element-1375" />
      <PricingSection data-id="element-1376" />
      <AverageRatingSection data-id="element-1377" />
      <TestimonialsGridSection data-id="element-1378" />
      <UrgencySection data-id="element-1379" />
      <FAQSection data-id="element-1380" />
    </main>
    <Footer data-id="element-1381" />
    <SocialProofNotification data-id="element-1382" />
  </div>;